import { render, staticRenderFns } from "./commandeclient_add.vue?vue&type=template&id=4fb6c776&scoped=true&"
import script from "./commandeclient_add.vue?vue&type=script&lang=js&"
export * from "./commandeclient_add.vue?vue&type=script&lang=js&"
import style0 from "./commandeclient_add.vue?vue&type=style&index=0&id=4fb6c776&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4fb6c776",
  null
  
)

export default component.exports